<template>
  <AnstalldContainer>
    <template v-if="individStore.individ.data">
      <AnstalldHeader class="overflow-visible" />
      <ContainerGrid scrollable>
        <MainColumn class="grid-rows-[auto_1fr]">
          <InsightsWidget :individId="individStore.individ.data.id" />
          <DetailsGrid>
            <template v-if="showContent">
              <DetailsColumn>
                <BasuppgifterSection
                  v-on:retry="
                    () =>
                      anstalldStore.fetchBasuppgifter(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <ArbetsgivareSection
                  v-on:retry="
                    () =>
                      anstalldStore.fetchArbetsgivare(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <PremierSection
                  v-on:retry="
                    () =>
                      anstalldStore.fetchPremier(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <AdressSection />
              </DetailsColumn>
              <DetailsColumn>
                <ITP1Section
                  v-if="anstalldStore.hasItp1"
                  v-on:retry="
                    () =>
                      anstalldStore.fetchItp1(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <ITP2Section
                  v-if="anstalldStore.hasItp2"
                  v-on:retry="
                    () =>
                      anstalldStore.fetchItp2(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <IndividuellaValSection
                  v-on:retry="
                    () =>
                      anstalldStore.fetchIndividuellaVal(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
                <EfterlevandeskyddSection
                  v-if="anstalldStore.hasEfterlevandeskydd"
                  v-on:retry="
                    () =>
                      anstalldStore.fetchEfterlevandeskydd(
                        individStore.individ.data?.id!,
                        apiClient,
                      )
                  "
                />
              </DetailsColumn>
            </template>
            <div class="col-span-2" v-if="hideSkyddadIdentitetContent">
              Denna person har skyddad identitet och du har inte behörighet att
              se informationen för denna individ. Lämna över ärendet till
              behörig användare.
            </div>
          </DetailsGrid>
        </MainColumn>
        <SidebarColumn
          class="overflow-hidden"
          v-if="!individStore.individ.error"
        >
          <RightSideBar />
        </SidebarColumn>
      </ContainerGrid>
      <div
        class="mt-md flex w-1/2 flex-col self-center bg-white p-lg"
        v-if="individStore.individ.error"
      >
        <p>Misslyckades att hämta data</p>
        <p>{{ individStore.individ.error.title }}</p>
        <p>{{ individStore.individ.error.errors }}</p>
      </div>
    </template>
    <div class="m-8" v-if="individStore.individ.isLoading">
      <avtalat-spinner big />
    </div>
  </AnstalldContainer>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from "vue";

import InsightsWidget from "./anstalld-insights-widget";
import {
  ContainerGrid,
  DetailsColumn,
  DetailsGrid,
  MainColumn,
  SidebarColumn,
} from "@/layout";
import { useApi } from "@/composables/useApi";
import { useConfirmNavigation } from "@/composables/useConfirmNavigation";
import { useNavigation } from "@/composables/useNavigation";
import { useIndividStore, useUserProfileStore } from "@/stores";

import AnstalldContainer from "./AnstalldContainer.vue";
import AnstalldHeader from "./AnstalldHeader.vue";
import RightSideBar from "./RightSideBar.vue";
import {
  AdressSection,
  ArbetsgivareSection,
  BasuppgifterSection,
  EfterlevandeskyddSection,
  ITP1Section,
  ITP2Section,
  IndividuellaValSection,
  PremierSection,
} from "./sections";
import { useAnstalldStore } from "./store";

const navigation = useNavigation();
useConfirmNavigation();

const apiClient = useApi();
const individStore = useIndividStore();
const anstalldStore = useAnstalldStore();
const userProfileStore = useUserProfileStore();

const getAnstalld = async () => {
  await individStore.fetchIndivid(
    navigation.currentRoute.query.id as string,
    navigation.currentRoute.query.personnummer as string,
    apiClient,
  );

  if (
    individStore.individ.data?.id &&
    individStore.individ.data?.avliden === false
  ) {
    anstalldStore.fetchAnstalld(apiClient);
  }
};

onMounted(() => {
  getAnstalld();
});

onBeforeUnmount(() => {
  anstalldStore.$reset();
});

const hideSkyddadIdentitetContent = computed(
  () =>
    individStore.individ.data?.skyddadPersonuppgift &&
    !userProfileStore.hasAnstalldSkyddadIdentitetAccess,
);

const showContent = computed(
  () =>
    individStore.individ.data &&
    !individStore.individ.data.avliden &&
    !hideSkyddadIdentitetContent.value,
);
</script>
